// Currency handling for the Invest tab.
//
// The old code assumed every market price was in USD and multiplied by "units of profile currency per USD".
// That is wrong for anything listed elsewhere: BHP.AX is quoted in AUD, so an Australian user saw
// 45 AUD x 1.52 = 68 "AUD". Now every quote carries the currency it was quoted in, and conversion goes
// quote currency -> profile currency through a USD-based rate table (cross rates fall out of that).

// Some exchanges quote in a minor unit (London pence, Johannesburg cents, Tel Aviv agorot).
const MINOR = { GBX: ["GBP", 100], GBp: ["GBP", 100], ZAc: ["ZAR", 100], ZAC: ["ZAR", 100], ILA: ["ILS", 100] };

export function normalizeQuote(price, currency) {
  const m = MINOR[currency];
  if (m) return { price: price / m[1], currency: m[0] };
  return { price, currency: currency ? String(currency).toUpperCase() : null };
}

// table = { rates: { USD: 1, AUD: 1.52, NZD: 1.68, ... }, ts } — units of each currency per 1 USD.
export function rate(from, to, table) {
  if (!from || !to || from === to) return 1;
  const r = table?.rates;
  if (!r || !r[from] || !r[to]) return null;
  return r[to] / r[from];
}

// null when a rate is missing — callers must show the amount in its own currency instead of guessing.
export function convert(amount, from, to, table) {
  const r = rate(from, to, table);
  return r === null ? null : amount * r;
}

// Which currency a symbol is normally quoted in, used only until a real quote tells us.
const SUFFIX_CCY = { AX: "AUD", NZ: "NZD", TO: "CAD", V: "CAD", L: "GBP", SI: "SGD", T: "JPY", NS: "INR", BO: "INR", HK: "HKD", DE: "EUR", PA: "EUR", AS: "EUR", MI: "EUR" };
export function guessCurrency(symbol, assetType) {
  if (assetType === "crypto") return "USD";
  const m = /\.([A-Z]{1,2})$/.exec(String(symbol || "").toUpperCase());
  return (m && SUFFIX_CCY[m[1]]) || "USD";
}

// The old behaviour, kept only so tests can demonstrate the bug it caused.
export const legacyConvert = (rawPrice, usdRate) => rawPrice * usdRate;
